
import {Component, Vue} from "vue-property-decorator";
import $ from "jquery";
import {EXPERIMENT_ESTHER_ADS} from "@/views/Experiments";

@Component
export default class Home2 extends Vue {
  private adsSidebar300: string;
  private adsSidebarTall: string;
  private adsFooterSm: string;
  private adsFooterMd: string;
  private adsFooterLg: string;
  private adsSection2Footer: string;
  private adsSection2Sidebar: string;
  private adsSection3Footer: string;
  private adsSection3Tall: string;
  private adsSection4Tall: string;
  private isEstherAds = false;

  public mounted() {
    fetch('/experiments')
        .then(response => response.json())
        .then(data => {
          this.isEstherAds = data[EXPERIMENT_ESTHER_ADS];
          this.onMounted();
        }).catch(error => {
          console.error(error);
          this.onMounted();
        });
  }

  private innerHtml(id: string) {
    const el = document.getElementById(id);
    if (el) {
      const innerHtml = el.innerHTML;
      el.remove();
      return innerHtml;
    }
    return "";
  }

  private onMounted() {
    this.adsSidebar300 = this.innerHtml('ads-sidebar-300-tmpl');
    // this.adsSidebarTall = this.isEstherAds
    //     ? document.getElementById("ads-sidebar-esther-tmpl").innerHTML
    //     : document.getElementById('ads-sidebar-tall-tmpl').innerHTML;
//this.adsSidebarTall = document.getElementById('ads-sidebar-tall-tmpl').innerHTML;
//    document.getElementById('ads-sidebar-tall-tmpl').remove();
    this.adsFooterSm = this.innerHtml('ads-footer-sm-tmpl');
    this.adsFooterMd = this.innerHtml('ads-footer-md-tmpl');
    this.adsFooterLg = this.innerHtml('ads-footer-lg-tmpl');
    this.adsSection2Sidebar = this.innerHtml('ads-section2-tall-tmpl');
    this.adsSection2Footer = this.innerHtml('ads-section2-footer-tmpl');
    this.adsSection3Footer = this.innerHtml('ads-section3-footer-tmpl');
    this.adsSection3Tall = this.innerHtml('ads-section3-tall-tmpl');
    this.adsSection4Tall = this.innerHtml('ads-section4-tall-tmpl');
    window.adsbygoogle = window.adsbygoogle || [];

    let displayedCount = 0;
    if (this.isDisplayed('#ads-sidebar-tall')) {
      document.getElementById('ads-sidebar-tall').innerHTML = this.adsSidebarTall;
      displayedCount++;
    }
    if (this.isDisplayed('#ads-sidebar-300')) {
      document.getElementById('ads-sidebar-300').innerHTML = this.adsSidebar300;
      displayedCount++;
    }
    // if (this.isDisplayed('#ads-footer-sm')) {
    //   document.getElementById('ads-footer-sm').innerHTML = this.adsFooterSm;
    //   displayedCount++;
    // }
    // if (this.isDisplayed('#ads-footer-md')) {
    //   document.getElementById('ads-footer-md').innerHTML = this.adsFooterMd;
    //   displayedCount++;
    // }
    // if (this.isDisplayed('#ads-footer-lg')) {
    //   document.getElementById('ads-footer-lg').innerHTML = this.adsFooterLg;
    //   displayedCount++;
    // }
    if (this.isDisplayed('#ads-section2-sidebar-tall')) {
      document.getElementById('ads-section2-sidebar-tall').innerHTML = this.adsSection2Sidebar;
      displayedCount++;
    }
    // if (this.isDisplayed('#ads-section2-footer')) {
    //   document.getElementById('ads-section2-footer').innerHTML = this.adsSection2Footer;
    //   displayedCount++;
    // }
    // if (this.isDisplayed('#ads-section3-footer')) {
    //   document.getElementById('ads-section3-footer').innerHTML = this.adsSection3Footer;
    //   displayedCount++;
    // }
    if (this.isDisplayed('#ads-section3-tall')) {
      document.getElementById('ads-section3-tall').innerHTML = this.adsSection3Tall;
      displayedCount++;
    }
    if (this.isDisplayed('#ads-section4-tall')) {
      document.getElementById('ads-section4-tall').innerHTML = this.adsSection4Tall;
      displayedCount++;
    }
    try {
      for (let i = 0; i < displayedCount; i++) {
        window.adsbygoogle.push({});
      }
      // window.adsbygoogle.push({});
      // window.adsbygoogle.push({});
      // window.adsbygoogle.push({});
      // window.adsbygoogle.push({});
    } catch (e) {
      console.log(e);
    }
  }

  private isDisplayed(selector: string): boolean {
    const displayCss = $(selector).css("display");
    return displayCss != null && displayCss !== "none";
  }

}
